var map = {
	"./": [
		812,
		9
	],
	"./App": [
		770,
		9
	],
	"./App.css": [
		50,
		9
	],
	"./App.js": [
		770,
		9
	],
	"./Components/AccountRemoval": [
		296,
		9
	],
	"./Components/AccountRemoval.css": [
		631,
		9
	],
	"./Components/AccountRemoval.jsx": [
		296,
		9
	],
	"./Components/ResearchContext": [
		983,
		9
	],
	"./Components/ResearchContext.jsx": [
		983,
		9
	],
	"./Components/Subcomponents/GAuth": [
		201,
		9
	],
	"./Components/Subcomponents/GAuth.css": [
		424,
		9
	],
	"./Components/Subcomponents/GAuth.jsx": [
		201,
		9
	],
	"./Components/Subcomponents/Modal": [
		683,
		9
	],
	"./Components/Subcomponents/Modal.css": [
		38,
		9
	],
	"./Components/Subcomponents/Modal.jsx": [
		683,
		9
	],
	"./index": [
		812,
		9
	],
	"./index.css": [
		555,
		9
	],
	"./index.js": [
		812,
		9
	],
	"./secrets": [
		717,
		7
	],
	"./secrets.js": [
		717,
		7
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 531;
module.exports = webpackAsyncContext;